import React from 'react';
import PropTypes from 'prop-types';

import { scientificFormat } from '../../utils/helpers/formatting';

const linkStyle = { display: 'flex', alignItems: 'center', margin: '3px 0', color: 'inherit' };

// Fixed box so a Semantic font icon and an SVG share a left edge. Left-aligned rather than
// centred because Semantic's Icon carries a trailing margin that would skew centring.
const iconBoxStyle = {
  width: 18,
  height: 18,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexShrink: 0,
  overflow: 'hidden',
};

const labelStyle = { marginLeft: 8 };

const PlatformLink = ({ href, icon, handle, count }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={e => e.stopPropagation()}
    style={linkStyle}
  >
    <span style={iconBoxStyle}>{icon}</span>
    <span style={labelStyle}>
      @{handle}
      <span style={{ color: '#9090a0', marginLeft: 6 }}>{scientificFormat(count)}</span>
    </span>
  </a>
);

PlatformLink.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  handle: PropTypes.string,
  count: PropTypes.number,
};

PlatformLink.defaultProps = {
  handle: '',
  count: 0,
};

export default PlatformLink;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/platform-link.js
 **/